<template>
  <router-view />
</template>

<script>
export default {
  name: 'HotelsAmendmentsIndex'
}
</script>
